import React, { Component } from 'react';
import isNil from 'lodash/fp/isNil';
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Glyphicon } from 'react-bootstrap';
import styled from 'styled-components';

const RJRModalHeader = styled(Modal.Header)`

    display: flex;
    align-items: flex-start;
    border-bottom: none;

    h4 {
        flex: 1 1 auto;
        padding: 0 20px 0 10px;
    }

    > div {
        flex: 1;
    }
`;

const RJRModalButtonContainer = styled.div`
    margin:20px 0px;
`


class RJRModal extends Component {

    constructor(props) {
        super(props);        
        this.state = {
            show: false
        }
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }
      
    // Add listeners immediately after the component is mounted.
    componentDidMount() {
        window.addEventListener('keyup', this.handleKeyUp, false);
        document.addEventListener('click', this.handleOutsideClick, false);
    }
    
    // Remove listeners immediately before a component is unmounted and destroyed.
    componentWillUnmount() {
        window.removeEventListener('keyup', this.handleKeyUp, false);
        document.removeEventListener('click', this.handleOutsideClick, false);
    }

    // Handle the key press event.
    handleKeyUp(e) {
        const { onCloseRequest } = this.props;
        const keys = {
        27: () => {
            e.preventDefault();
            onCloseRequest();
            window.removeEventListener('keyup', this.handleKeyUp, false);
        },
        };

        if (keys[e.keyCode]) { keys[e.keyCode](); }
    }

      // Handle the mouse click on browser window.
    handleOutsideClick(e) {
        const { onCloseRequest } = this.props;

        if (!isNil(this.modal)) {
            if (!this.modal.contains(e.target)) {
                onCloseRequest();
                document.removeEventListener('click', this.handleOutsideClick, false);
            }
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.showModal === true) {
            this.setState({show:true});
        } else {
            this.setState({show:false});
        }
    }

	handleClose() {
        this.showModal = false;
		this.setState({ show: false });
	}

    render() {
        const {
            onCloseRequest,
            modalContent,
            title,
        } = this.props;

        return (
            <div>
                <Modal show={this.state.show}>
                    <RJRModalHeader>
                        <h4>{title}</h4>
                        <Button onClick={onCloseRequest} bsSize="xsmall">
                            <Glyphicon glyph="remove" />
                        </Button>                       
                    </RJRModalHeader>
                    <Modal.Body>
                        <div>
                            {/* This is the dynamic component we're passing in as a prop to render out the content of the modal */}
                            {modalContent}
                            <RJRModalButtonContainer>
                                <Button onClick={onCloseRequest} bsStyle="primary">OK</Button>
                            </RJRModalButtonContainer>
                        </div>                    
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default RJRModal;




// WEBPACK FOOTER //
// ./src/components/shared/modal.js